import { useState, useEffect } from 'react';

export const useBudgetSuggestionData = ({
  loadBudgetPartial,
  fetchCustomBudgetPerformanceData,
  cpa,
  roas,
  bidStrategy,
  campaign,
  budgetTier,
  budgetAmount,
  shouldShowBudgetSuggestion,
}) => {
  const EnableBudgetSuggestion = shouldShowBudgetSuggestion;

  const [isBudgetSuggestionLoading, setIsBudgetSuggestionLoading] = useState(false);

  const [budgetSuggestionData, setBudgetSuggestionData] = useState(null);

  const [customPerformanceData, setCustomPerformanceData] = useState(null);

  useEffect(() => {
    if (loadBudgetPartial && bidStrategy && campaign && campaign.BiddingScheme.Type !== bidStrategy && EnableBudgetSuggestion) {
      setIsBudgetSuggestionLoading(true);

      loadBudgetPartial({
        BiddingScheme: {
          Type: bidStrategy,
          TargetCpa: cpa,
          TargetRoas: roas,
        },
      }).then((budgetSuggestions) => {
        setBudgetSuggestionData(budgetSuggestions);
        setIsBudgetSuggestionLoading(false);
      }).catch(() => {
        setIsBudgetSuggestionLoading(false);
      });
    }
  }, [EnableBudgetSuggestion, bidStrategy, campaign, cpa, loadBudgetPartial, roas]);


  useEffect(() => {
    if (loadBudgetPartial && EnableBudgetSuggestion) {
      setIsBudgetSuggestionLoading(true);

      loadBudgetPartial({
        BiddingScheme: {
          Type: bidStrategy,
          TargetCpa: cpa,
          TargetRoas: roas,
        },
      }).then((budgetSuggestions) => {
        setBudgetSuggestionData(budgetSuggestions);
        setIsBudgetSuggestionLoading(false);
      }).catch(() => {
        setIsBudgetSuggestionLoading(false);
      });
    }
  }, [EnableBudgetSuggestion, bidStrategy, cpa, loadBudgetPartial, roas]);

  useEffect(() => {
    if (budgetTier === 'CustomBudget' && EnableBudgetSuggestion) {
      setCustomPerformanceData({ isLoading: true });

      if (fetchCustomBudgetPerformanceData && parseInt(budgetAmount, 10) > 0) {
        fetchCustomBudgetPerformanceData({ budgetAmount })
          .then(result => setCustomPerformanceData({ isLoading: false, ...result }))
          .catch(() => setCustomPerformanceData({ isLoading: false }));
      }
    }
  }, [EnableBudgetSuggestion, budgetAmount, budgetTier, fetchCustomBudgetPerformanceData]);

  return {
    isBudgetSuggestionLoading,
    budgetSuggestionData,
    customPerformanceData,
  };
};
